var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtaAddIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_12887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3205 10.7083H10.7495V13.257C10.7495 13.6673 10.4139 14 10 14C9.58605 14 9.25048 13.6673 9.25048 13.257V10.7083H6.67955C6.29342 10.6687 6 10.3461 6 9.96132C6 9.5765 6.29342 9.25394 6.67955 9.21431H9.24242V6.67365C9.28241 6.29088 9.60778 6 9.99597 6C10.3842 6 10.7095 6.29088 10.7495 6.67365V9.21431H13.3205C13.7066 9.25394 14 9.5765 14 9.96132C14 10.3461 13.7066 10.6687 13.3205 10.7083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 1H5.8C2.736 1 1 2.736 1 5.8V14.2C1 17.256 2.728 19 5.8 19H14.2C17.264 19 19 17.256 19 14.2V5.8C19 2.736 17.264 1 14.2 1Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_12887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaAddIconWhite);
export default __webpack_public_path__ + "static/media/ctaAddIconWhite.1a47df40418388fc19c17072b0d0de43.svg";
export { ForwardRef as ReactComponent };